import { useQuery } from '@apollo/client';
import { useAuth } from 'contexts/AuthContext';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { get } from 'lodash';
import { useMemo } from 'react';
import { EQuizId, quizContextType } from 'types/quiz';

export const useGetGender = (skip: boolean) => {
    const { currentUser } = useAuth();
    const { data: genderData } = useQuery(GET_QUIZ_RESPONSE, {
        variables: {
            input: {
                quizId: EQuizId.GENDER_QUIZ,
                contextType: quizContextType,
                contextId: EQuizId.GENDER_QUIZ,
                userId: currentUser?.uid,
            },
        },
        skip: skip,
    });
    const gender = useMemo(
        () => get(genderData, ['getQuizResponse', 'answers', 'gender_question', 'value'])?.toLowerCase(),
        [genderData],
    );
    return gender;
};
